import { readProductTaxonomyFields } from './readProductTaxonomyFields'
import { splitMainAndExtraAssignments } from './productTaxonomyUx'

const PATH_SEPARATOR = ' → '

export function buildCatalogTaxonomyNodesById(nodes = []) {
  const nodesById = {}
  nodes.forEach((node) => {
    if (node?.id) nodesById[node.id] = node
  })
  return nodesById
}

export function buildCatalogTaxonomyNodePathLabel(nodeId, nodesById = {}) {
  return buildCatalogTaxonomyNodePathSegments(nodeId, nodesById)
    .map((segment) => segment.name)
    .join(PATH_SEPARATOR)
}

/** Root → … → leaf segments for chip / breadcrumb UI. */
export function buildCatalogTaxonomyNodePathSegments(nodeId, nodesById = {}) {
  if (!nodeId) return []

  const segments = []
  let currentId = nodeId
  const seen = new Set()

  while (currentId && !seen.has(currentId)) {
    seen.add(currentId)
    const node = nodesById[currentId]
    if (!node) {
      segments.unshift({ id: currentId, name: '?' })
      break
    }
    segments.unshift({ id: node.id, name: node.name || '?' })
    currentId = node.parentId || null
  }

  return segments
}

/**
 * Table / card facing taxonomy display:
 * - mainLine: path or "Не вибрано"
 * - extrasLines: paths of additional leaf assignments only (not ancestors)
 */
export function formatProductTaxonomySummary(product, nodesById = {}) {
  const split = splitMainAndExtraAssignments(product)
  const taxonomy = readProductTaxonomyFields(product)

  const mainLine = split.hasMain
    ? buildCatalogTaxonomyNodePathLabel(split.mainId, nodesById) || split.mainId
    : 'Не вибрано'

  const extrasLines = split.extraIds.map(
    (id) => buildCatalogTaxonomyNodePathLabel(id, nodesById) || id
  )

  const extrasPreviewLines =
    extrasLines.length <= 2
      ? extrasLines
      : [extrasLines[0], `+${extrasLines.length - 1} категорії`]

  return {
    text: split.hasMain
      ? extrasLines.length
        ? `${mainLine} (+${extrasLines.length})`
        : mainLine
      : taxonomy.catalogTaxonomyAssignmentIds.length
        ? 'Без основної категорії'
        : 'Без категорій',
    mainLine,
    extrasLines,
    extrasPreviewLines,
    extraCount: extrasLines.length,
    hasMain: split.hasMain,
    hasAssignments: split.hasAssignments,
    sortKey: split.hasMain ? mainLine : '',
    lines: split.hasMain
      ? extrasLines.length
        ? [mainLine, `+${extrasLines.length} додаткові`]
        : [mainLine]
      : split.hasAssignments
        ? ['Без основної категорії']
        : [],
    tooltipLines: [
      `Основна: ${mainLine}`,
      ...extrasLines.map((line) => `Додаткова: ${line}`),
    ],
  }
}
